<template>
  <div>
    <ul class='flex gap-2'>
      <li v-for='score in scores' class='flex gap-1 items-center'>
        <span class='rounded-sm w-6 h-6 inline-block' :class='scoreMap.getColour(score, "bg", "high")' />
        <span class='text-sm'>{{ scoreMap.getLabel(score) }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup>

import { scoreMap } from '@/kernel/scoring';

const scores = [-3, -2, -1, 0];

</script>